import { ArrowRight, MessageCircle } from "lucide-react";
import { config } from "@/config";

export default function ClosingBlock() {
  const scrollToForm = () => {
    document.getElementById("formulario")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="closing-block"
      className="py-20 md:py-28 bg-[#0A1628] text-white relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4C4A8]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#0F3D56]/20 rounded-full blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        {/* Content */}
        <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#D4C4A8] mb-6 block">
          Siguiente paso
        </span>
        
        <h2
          className="text-2xl md:text-4xl lg:text-5xl font-semibold text-white mb-8 leading-tight"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          ¿Evaluando una ruta de Ecommerce más estructurada?
        </h2>
        
        <p className="text-base md:text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto mb-10">
          Si estás evaluando una propuesta de Ecommerce con contenido organizado, 
          recursos complementarios y un proceso de orientación claro, puedes solicitar 
          información y revisar con DSA si esta propuesta encaja contigo.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="closing-cta-primary"
            onClick={scrollToForm}
            className="group bg-white text-[#0A1628] px-10 py-5 text-base font-bold hover:bg-[#D4C4A8] transition-all duration-300 tracking-wide flex items-center justify-center gap-2"
          >
            Solicitar Información
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href={config.whatsapp.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="closing-cta-secondary"
            className="border border-white/30 text-white px-10 py-5 text-base font-medium hover:bg-white/10 hover:border-white/50 transition-all duration-300 tracking-wide flex items-center justify-center gap-2"
          >
            <MessageCircle size={18} />
            Hablar por WhatsApp
          </a>
        </div>

        {/* Trust Note */}
        <p className="text-sm text-gray-500 mt-10 max-w-xl mx-auto">
          Sin compromiso. Sin presión. Solo información clara para que tomes una decisión informada.
        </p>
      </div>
    </section>
  );
}
